"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SIMPLIFIED_WEB_VIEWPORT_LABEL_MIN_PINNED_PRODUCT_TEMPLATE = void 0;
exports.supportsSimplifiedWebViewportLabels = supportsSimplifiedWebViewportLabels;
exports.getViewportLabel = getViewportLabel;
exports.SIMPLIFIED_WEB_VIEWPORT_LABEL_MIN_PINNED_PRODUCT_TEMPLATE = 50500;
function supportsSimplifiedWebViewportLabels(pinnedProductTemplate) {
    return (pinnedProductTemplate !== null && pinnedProductTemplate !== void 0 ? pinnedProductTemplate : 0) >= exports.SIMPLIFIED_WEB_VIEWPORT_LABEL_MIN_PINNED_PRODUCT_TEMPLATE;
}
/**
 * Convert a viewport object and modality into a human-readable label.
 */
function getViewportLabel(vp, modality, { useSimplifiedWebLabels = false } = {}) {
    var _a;
    if (modality === 'ios') {
        return 'iOS';
    }
    const key = `${vp.width}x${vp.height}`;
    const map = modality === 'web' && useSimplifiedWebLabels
        ? {
            '375x812': 'Mobile',
            '810x1010': 'Tablet portrait',
            '1010x810': 'Tablet landscape',
            '1366x768': 'Desktop',
        }
        : {
            '375x812': 'Web mobile',
            '810x1010': 'Web iPad portrait',
            '1010x810': 'Web iPad landscape',
            '1366x768': 'Web desktop',
            '412x915': 'Android',
        };
    return (_a = map[key]) !== null && _a !== void 0 ? _a : `Web ${vp.width}×${vp.height}`;
}
//# sourceMappingURL=viewport.js.map